export default "__VITE_ASSET__DOqKJ41C__$_?nuxt_component=async&nuxt_component_name=SvgoHomeIcService&nuxt_component_export=default__"